import Logo from '../assets/icons/menu-icon/logo.png';
import { ReactComponent as TriggerIcon } from '../assets/icons/menu-icon/trigger.svg';
import SvgIcon from '../components/SvgIcon';
import { useEffect, useState } from 'react';
import { ReactComponent as HomeIcon } from '../assets/icons/menu-icon/home.svg';
import { ReactComponent as ProductIcon } from '../assets/icons/menu-icon/products.svg';
import { ReactComponent as OderIcon } from '../assets/icons/menu-icon/order.svg';
import { ReactComponent as ManufacturingRequestIcon } from '../assets/icons/menu-icon/manufacturing-request.svg';
import '../styles/layouts/base-layout.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGlobalStore } from '../stores/globalState';
import { MENU_ROUTES } from '../utils/constants/routes';

interface MenuItem {
  key: string;
  label: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

const items: MenuItem[] = [
  {
    key: MENU_ROUTES.HOME,
    label: 'HOME',
    icon: HomeIcon,
  },
  {
    key: MENU_ROUTES.PRODUCTS,
    label: '製品マスタ',
    icon: ProductIcon,
  },
  {
    key: MENU_ROUTES.ORDERS,
    label: '手配作成',
    icon: OderIcon,
  },
  {
    key: MENU_ROUTES.PRODUCTION,
    label: '製造管理',
    icon: ManufacturingRequestIcon,
  },
  // {
  //   key: MENU_ROUTES.IMPORT_HISTORY,
  //   label: 'インポート履歴',
  //   icon: ManufacturingRequestIcon,
  // },
];

const Sider = () => {
  const { collapsed, toggleCollapsed } = useGlobalStore();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState(location.pathname.split('/')[1] || 'home');

  useEffect(() => {
    setActiveKey(location.pathname.split('/')[1] || 'home');
  }, [location]);

  /**
   * Handling when clicking on a menu item
   * @param key
   * @param route
   */
  const handleItemClick = (key: string) => {
    setActiveKey(key); // Update active status
    navigate(`/${key}`); // Navigate to the corresponding route
  };

  return (
    <div className="sys-layout__sider" style={{ width: collapsed ? '80px' : '254px' }}>
      <div className="sys-layout__logo-menu">
        <img src={Logo} alt="logo" />
        {!collapsed && <span>Management</span>}
      </div>

      <ul className="sys-menu">
        {items.map(item => (
          <li
            key={item.key}
            className={`sys-menu-item ${activeKey === item.key ? 'sys-active' : ''}  ${collapsed ? 'sys-collapsed' : ''}`}
            onClick={() => handleItemClick(item.key)}
          >
            <span className="sys-menu-icon">
              <SvgIcon svg={item.icon} width={32} height={32} fill={activeKey === item.key ? 'FF5500' : ''} />
            </span>
            {!collapsed && <span className="sys-menu-title-content">{item.label}</span>}
          </li>
        ))}
      </ul>

      <div className="sys-layout-sider-trigger" style={{ width: collapsed ? '80px' : '254px' }} onClick={toggleCollapsed}>
        <span
          className="anticon"
          style={{
            transform: collapsed ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease-in-out',
          }}
        >
          <SvgIcon svg={TriggerIcon} width={32} height={32} />
        </span>
      </div>
    </div>
  );
};

export default Sider;
